import { render, staticRenderFns } from "./userPageSidebar.vue?vue&type=template&id=55d5b99f&scoped=true"
import script from "./userPageSidebar.vue?vue&type=script&lang=js"
export * from "./userPageSidebar.vue?vue&type=script&lang=js"
import style0 from "./userPageSidebar.vue?vue&type=style&index=0&id=55d5b99f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d5b99f",
  null
  
)

export default component.exports